import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import PerfectScrollbar from "perfect-scrollbar";

import { Nav, Collapse } from "reactstrap";
import PATHS from "constant/paths";
import { itemKey, moveKey, visibleKeys } from "utils/menuOrder";

var ps;

const Sidebar = (props) => {
  const { t } = useTranslation("nav");
  const [state, setState] = React.useState({});
  const sidebarRef = React.useRef(null);
  // Modalita' "Ordina menu": elenco semplice delle voci principali da trascinare.
  const [draft, setDraft] = React.useState(null); // null = non si sta ordinando
  const [saving, setSaving] = React.useState(false);
  const dragKey = React.useRef(null);
  const location = useLocation();
  React.useEffect(() => {
    setState(getCollapseStates(props.routes));
  }, []);
  // React.useEffect(() => {
  //   if (navigator.platform.indexOf("Win") > -1) {
  //     ps = new PerfectScrollbar(sidebarRef.current, {
  //       suppressScrollX: true,
  //       suppressScrollY: false,
  //     });
  //   }
  //   return function cleanup() {
  //     if (navigator.platform.indexOf("Win") > -1) {
  //       ps.destroy();
  //     }
  //   };
  // });
  // function isWindowsPlatform() {
  //   if (navigator.userAgentData) {
  //     return navigator.userAgentData.platform === "Windows";
  //   } else {
  //     return navigator.userAgent.includes("Windows");
  //   }
  // }

  // React.useEffect(() => {
  //   if (isWindowsPlatform()) {
  //     ps = new PerfectScrollbar(sidebarRef.current, {
  //       suppressScrollX: true,
  //       suppressScrollY: false,
  //     });
  //   }

  //   return function cleanup() {
  //     if (isWindowsPlatform()) {
  //       ps?.destroy();
  //     }
  //   };
  // }, []);

  const getCollapseStates = (routes) => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: getCollapseInitialState(prop.views),
          ...getCollapseStates(prop.views),
          ...initialState,
        };
      }
      return null;
    });
    return initialState;
  };
  const getCollapseInitialState = (routes) => {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (window.location.href.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  };
  const createLinks = (routes) => {
    const { rtlActive } = props;
    return routes
      .filter((prop) => prop.showSidebar !== false)
      .map((prop, key) => {
        if (prop.redirect) {
          return null;
        }
        if (prop.collapse) {
          var st = {};
          st[prop["state"]] = !state[prop.state];
          return (
            <li
              className={getCollapseInitialState(prop.views) ? "active" : ""}
              key={key}
            >
              <a
                href="#pablo"
                data-toggle="collapse"
                aria-expanded={state[prop.state]}
                onClick={(e) => {
                  e.preventDefault();
                  setState({ ...state, ...st });
                }}
              >
                {prop.icon !== undefined ? (
                  <>
                    <i className={prop.icon} />
                    <p>
                      {rtlActive ? prop.rtlName : prop.name}
                      <b className="caret" />
                    </p>
                  </>
                ) : (
                  <>
                    <span className="sidebar-mini-icon">
                      {rtlActive ? prop.rtlMini : prop.mini}
                    </span>
                    <span className="sidebar-normal">
                      {rtlActive ? prop.rtlName : prop.name}
                      <b className="caret" />
                    </span>
                  </>
                )}
              </a>
              <Collapse isOpen={state[prop.state]}>
                <ul className="nav">{createLinks(prop.views)}</ul>
              </Collapse>
            </li>
          );
        }
        return (
          <li className={activeRoute(prop.path)} key={key}>
            <NavLink to={prop.path} onClick={props.closeSidebar}>
              {prop.icon !== undefined ? (
                <>
                  <i className={prop.icon} />
                  <p>{rtlActive ? prop.rtlName : prop.name}{prop.badge}</p>
                </>
              ) : (
                <>
                  <span className="sidebar-mini-icon">
                    {rtlActive ? prop.rtlMini : prop.mini}
                  </span>
                  <span className="sidebar-normal">
                    {rtlActive ? prop.rtlName : prop.name}
                    {prop.badge}
                  </span>
                </>
              )}
            </NavLink>
          </li>
        );
      });
  };
  const topItems = props.routes.filter((r) => r.showSidebar !== false && !r.redirect);
  const startOrdering = () => setDraft(visibleKeys(props.routes));
  const move = (key, beforeKey) => setDraft((d) => moveKey(d, key, beforeKey));
  const shiftKey = (key, step) => {
    const i = draft.indexOf(key);
    const j = i + step;
    if (j < 0 || j >= draft.length) return;
    move(key, step < 0 ? draft[j] : draft[j + 1] ?? null);
  };
  const saveOrdering = async () => {
    setSaving(true);
    try {
      const ok = await props.onSaveOrder?.(draft);
      if (ok !== false) setDraft(null);
    } finally {
      setSaving(false);
    }
  };
  const createOrderList = () => {
    const byKey = {};
    topItems.forEach((r) => (byKey[itemKey(r)] = r));
    return (
      <div className="sidebar-order">
        <p className="small text-muted px-3 mb-2">
          {t("sidebar.dragHint")}
        </p>
        <ul className="nav flex-column">
          {draft.map((key) => {
            const r = byKey[key];
            if (!r) return null;
            return (
              <li
                key={key}
                data-order-item={key}
                draggable
                onDragStart={(e) => {
                  dragKey.current = key;
                  e.dataTransfer?.setData?.("text/plain", key);
                }}
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => {
                  e.preventDefault();
                  if (dragKey.current) move(dragKey.current, key);
                  dragKey.current = null;
                }}
                onDragEnd={() => (dragKey.current = null)}
                style={{ display: "flex", alignItems: "center", padding: "6px 12px", cursor: "grab" }}
              >
                <span style={{ marginRight: 8, opacity: 0.6 }}>⠿</span>
                <i className={r.icon} style={{ marginRight: 8 }} />
                <span style={{ flex: 1 }}>{r.name}</span>
                <button type="button" className="btn btn-link btn-sm p-0 mr-1" aria-label={t("sidebar.up")} onClick={() => shiftKey(key, -1)}>↑</button>
                <button type="button" className="btn btn-link btn-sm p-0" aria-label={t("sidebar.down")} onClick={() => shiftKey(key, 1)}>↓</button>
              </li>
            );
          })}
          <li
            data-order-end
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
              e.preventDefault();
              if (dragKey.current) move(dragKey.current, null);
              dragKey.current = null;
            }}
            style={{ height: 24 }}
          />
        </ul>
        <div className="px-3 pb-3 d-flex">
          <button type="button" className="btn btn-primary btn-sm mr-2" onClick={saveOrdering} disabled={saving}>
            {saving ? t("sidebar.saving") : t("sidebar.save")}
          </button>
          <button type="button" className="btn btn-secondary btn-sm" onClick={() => setDraft(null)} disabled={saving}>
            {t("sidebar.cancel")}
          </button>
        </div>
      </div>
    );
  };
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    // Le voci con "?filtro" sono attive solo con lo stesso filtro.
    if (routeName && routeName.includes("?")) {
      return location.pathname + location.search === routeName ? "active" : "";
    }
    return location.pathname === routeName ? "active" : "";
  };

  const { activeColor, logo } = props;
  let logoImg = null;
  let logoText = null;
  if (logo !== undefined) {
    if (logo.outterLink !== undefined) {
      logoImg = (
        <Link
          to={PATHS.DASHBOARD}
          className="simple-text logo-mini"
          onClick={props.closeSidebar}
        >
          <div className="logo-img">
            <img src={logo.imgSrc} alt={t("sidebar.logoAlt")} />
          </div>
        </Link>
      );
      logoText = (
        <a
          href={logo.outterLink}
          className="simple-text logo-normal"
          onClick={props.closeSidebar}
        >
          {logo.text}
        </a>
      );
    } else {
      logoImg = (
        <NavLink
          to={logo.innerLink}
          className="simple-text logo-mini"
          onClick={props.closeSidebar}
        >
          <div className="logo-img">
            <img src={logo.imgSrc} alt={t("sidebar.logoAlt")} />
          </div>
        </NavLink>
      );
      logoText = (
        <NavLink
          to={logo.innerLink}
          className="simple-text logo-normal"
          onClick={props.closeSidebar}
        >
          {logo.text}
        </NavLink>
      );
    }
  }
  return (
    <div className="sidebar" data={activeColor}>
      <div className="sidebar-wrapper" ref={sidebarRef}>
        {logoImg !== null || logoText !== null ? (
          <div className="logo">
            {logoImg}
            {logoText}
          </div>
        ) : null}
        {draft ? (
          createOrderList()
        ) : (
          <>
            <Nav>{createLinks(props.routes)}</Nav>
            {props.onSaveOrder && topItems.length > 1 && (
              <div className="px-3 py-2">
                <button type="button" className="sidebar-order-btn" onClick={startOrdering}>
                  ⇅ {t("sidebar.orderMenu")}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

Sidebar.propTypes = {
  activeColor: PropTypes.oneOf(["primary", "blue", "green", "orange", "red"]),
  rtlActive: PropTypes.bool,
  routes: PropTypes.array.isRequired,
  logo: PropTypes.oneOfType([
    PropTypes.shape({
      innerLink: PropTypes.string.isRequired,
      imgSrc: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }),
    PropTypes.shape({
      outterLink: PropTypes.string.isRequired,
      imgSrc: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ]),
  closeSidebar: PropTypes.func,
  onSaveOrder: PropTypes.func,
};

export default Sidebar;
